import request from '@helpers/request';
import { API_DOCUMENTS_PATH, API_HOST_NAME } from '../env';

export const getDocumentsListService = ({
  name,
  limit,
  exclusiveStartKey,
  sort,
  category,
  type,
}) =>
  request(
    `${API_HOST_NAME}${API_DOCUMENTS_PATH}/list?type=${type}&name=${name}&category=${category}&limit=${limit}&exclusiveStartKey=${exclusiveStartKey}&sort=${sort}`,
    {
      method: 'GET',
    },
  );

export const getDocumentsDetailService = (documentId) =>
  request(`${API_HOST_NAME}${API_DOCUMENTS_PATH}/${documentId}`, {
    method: 'GET',
  });

export const getDocumentsLinkService = (documentId) =>
  request(`${API_HOST_NAME}${API_DOCUMENTS_PATH}/${documentId}/link`, {
    method: 'GET',
  });

export const getDocumentCategories = () =>
  request(`${API_HOST_NAME}${API_DOCUMENTS_PATH}/categories`, {
    method: 'GET',
  });

export const getDocumentFromS3 = ({ docType }) =>
  request(`${API_HOST_NAME}${API_DOCUMENTS_PATH}/export-url`, {
    method: 'GET',
    params: {
      docType,
    },
  });
